module.exports = __webpack_public_path__ + "static/media/collage-product.1897dc69.jpg";